import format from 'date-fns/format';
import setHours from 'date-fns/set_hours';
import setMinutes from 'date-fns/set_minutes';

export function parseTime(time) {
	const [hour, minute] = time.split(':');
	return setMinutes(setHours(new Date(), hour), minute);
}

export function getHourString(hour) {
	if (!hour) {
		return 'closed';
	}
	if (hour.appointmentOnly) {
		return 'By Appointment Only';
	}
	const openTime = format(parseTime(hour.open), 'h:mm a');
	const closeTime = format(parseTime(hour.closed), 'h:mm a');

	return openTime === closeTime ? 'closed' : `${openTime} - ${closeTime}`;
}
